import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Form, Input, Button, Typography, Space, InputNumber } from "antd";
import { toast } from "../../components/toasts/toastStore";
import { apiGastosInstance, authHeaderGastos } from "../../redux/actions/gastos/gastos";

import "./GastosPage.css";

const { Title, Text } = Typography;

export default function CrearGastoPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const gastoEdit = location.state?.gasto || null;
  const isEditing = !!gastoEdit;

  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    let values;
    try {
      values = await form.validateFields();
    } catch {
      return;
    }

    const payload = {
      concepto: values.concepto.trim(),
      monto: values.monto,
      fecha: values.fecha,
      nota: values.nota?.trim() || null,
    };

    setSaving(true);
    try {
      if (isEditing) {
        await apiGastosInstance.patch(`/gastos/${gastoEdit.id_gasto}`, payload, { headers: authHeaderGastos() });
        toast.success("Gasto actualizado correctamente");
      } else {
        await apiGastosInstance.post("/gastos", payload, { headers: authHeaderGastos() });
        toast.success("Gasto creado exitosamente");
      }
      navigate("/app/gastos");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error al guardar");
    } finally {
      setSaving(false);
    }
  };

  return (
    <main className="gas-main">
      <div className="gas-content">
        <div className="gas-header-section">
          <Space direction="vertical" size={2}>
            <Title level={2} className="gas-title">{isEditing ? "Editando gasto" : "Nuevo gasto"}</Title>
            <Text className="gas-subtitle">
              {isEditing ? "Modifica los datos del gasto y guarda los cambios." : "Registra un nuevo gasto de la tienda."}
            </Text>
          </Space>
          <Space>
            <Button onClick={() => navigate("/app/gastos")} disabled={saving}>Cancelar</Button>
            <Button type="primary" loading={saving} onClick={handleSave} style={{ backgroundColor: "#f90336", borderColor: "#f90336" }}>
              {isEditing ? "Guardar cambios" : "Crear gasto"}
            </Button>
          </Space>
        </div>

        <div className="gas-section-card">
          <div className="gas-section-header">
            <span className="gas-section-icon"><i className="fa-solid fa-money-bill-wave" /></span>
            Datos del gasto
          </div>
          <Form
            form={form}
            layout="vertical"
            initialValues={{
              concepto: gastoEdit?.concepto,
              monto: gastoEdit?.monto != null ? parseFloat(gastoEdit.monto) : undefined,
              fecha: gastoEdit?.fecha,
              nota: gastoEdit?.nota,
            }}
          >
            <Form.Item name="concepto" label={<span className="gas-field-label">Concepto</span>} rules={[{ required: true, message: "Requerido" }]}>
              <Input placeholder="Ej. Compra de bolsas para empaque" />
            </Form.Item>
            <Form.Item name="monto" label={<span className="gas-field-label">Monto</span>} rules={[{ required: true, message: "Requerido" }]}>
              <InputNumber style={{ width: "100%" }} min={0.01} precision={2} placeholder="0.00" />
            </Form.Item>
            <Form.Item name="fecha" label={<span className="gas-field-label">Fecha</span>} rules={[{ required: true, message: "Requerido" }]}>
              <input type="date" className="ant-input" style={{ width: "100%", height: 32, borderRadius: 6, border: "1px solid #d9d9d9", padding: "0 11px" }} />
            </Form.Item>
            <Form.Item name="nota" label={<span className="gas-field-label">Nota (opcional)</span>}>
              <Input.TextArea rows={3} maxLength={500} showCount placeholder="Detalles adicionales..." />
            </Form.Item>
          </Form>
        </div>
      </div>
    </main>
  );
}
